import script from "./ActionTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionTable.vue?vue&type=script&lang=ts&setup=true"

import "./ActionTable.vue?vue&type=style&index=0&id=6d3e36fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d3e36fc"]])

export default __exports__